import logo from './logo.png'
import logo2 from './seftenisteLogoM.svg'
import basket from './basket.png'
import hamburger from './hamburger-menu.svg'
import motorcycle from './motorcycle.png'
import corba from './corba.svg'
import portakal from './portakal.png'
import tatli from './tatli.svg'
import microphone from './microphone.png'
import apple from './apple.png'
import google from './google.png'
import turkey from './turkey.png'
import arrow from './arrow.png'
import phone2 from './phone2.png'
import stars from './stars.png'
import egg from './np_egg.png'
import gluten from './np_gluten.png'
import milk from './np_milk.png'
import mustard from './np_mustard.png'
import sesame from './np_sesame.png'
import soybean from './np_soy-bean.png'
import sulfide from './np_sulfide.png'
import multinet from './logoMulitnet.png'
import sodexo from './logoSodexo.png'
import plus from './plus.png'
import greenTick from './greentick.png'
import phoneNumber from './phoneNumber.png'
import facebookFooter from './facebook-footer.svg'
import twitterFooter from './twitter-footer.svg'
import instagramFooter from './instagram-footer.svg'
import youtubeFooter from './youtube-footer.svg'
import orangeBadge from './orangeBadge.svg'
import orangeBadge2 from './orangeBadge2.svg'
import orangeBadge3 from './orangeBadge3.svg'
import add2 from './Add2.png'
import plus2 from './Plus2.png'
import star_plain from './star_plain.svg'
import close from './close.svg'
import td_icon from './td_icon.svg'
import up from './up.svg'
import right from './rightArrow.svg'
import down from './down.svg'
import colorfulMotorcycle from './motocycle-colorful.svg'
import location from './location.svg'
import carrotDownFill from './caret-down-fill.svg'
import carrotDownFillGray from './caret-down-fill-gray.svg'
import carrotDownFillOrange from './caret-down-fill-orange.svg'
import plateDrdownSelected from './plate-drdown-selected.svg'
import arrowRightWhite from './arrow-white-sm.svg'
import addFillPrimary from './add-fill-primary.svg'
import clock from './clock.svg'
import lemonade from './limonata.svg'
import rightArrow from './rightArrowWhite.svg'
import downfill from './downfill.svg'
import logoMigrosYemek from './logoMigrosYemek.svg'
import logoGetir from './logoGetir.svg'
import logoYemekSepeti from './logoYemeksepeti.svg'
import pinMap from './pin-map.svg'
import modalInfo from './TD_iKON_V3_PAPRİKA_27.svg'
import checkCircle from './checkCircle.svg'
import leftArrow from './left-arrow.svg'
import downArrowDefaultColor from './downArrowDefaultColor.svg'
import chevronDown from './chevron-down.svg'
import buttonS from './ButtonS.png'
import attention from './icon-attention.svg'
import loading from './loadingSeftenISte.png'
import star from './star.svg'
import starHalf from './star-half.svg'
import starFill from './star-fill.svg'
import pinMapPrimary from './icnMap.svg'
import profile from './person-badge.svg'
import logout from './logut-icon.svg'
import receipt from './receipt-cutoff.svg'
import pinmapOrange from './pin-map-orange.svg'
import badgeHot from './badge-hot.svg'
import badgeHotEmpty from './badge-hot-empty.svg'
import badgeYellowBg from './badge-yellow-bg.svg'
import globe from './globe.svg'
import dropdownSelect from './dropdown-select.svg'
import cocukDunyasi from './sticker_CocukDunyasi.svg'

export default {
    logo,
    logo2,
    basket,
    hamburger,
    motorcycle,
    corba,
    portakal,
    tatli,
    microphone,
    apple,
    google,
    turkey,
    arrow,
    phone2,
    stars,
    egg,
    gluten,
    sesame,
    soybean,
    sulfide,
    milk,
    mustard,
    multinet,
    sodexo,
    plus,
    phoneNumber,
    facebookFooter,
    twitterFooter,
    instagramFooter,
    youtubeFooter,
    orangeBadge,
    orangeBadge2,
    orangeBadge3,
    add2,
    plus2,
    star_plain,
    close,
    td_icon,
    up,
    right,
    down,
    colorfulMotorcycle,
    location,
    carrotDownFill,
    arrowRightWhite,
    addFillPrimary,
    clock,
    lemonade,
    rightArrow,
    downfill,
    logoMigrosYemek,
    logoGetir,
    logoYemekSepeti,
    carrotDownFillGray,
    plateDrdownSelected,
    carrotDownFillOrange,
    pinMap,
    modalInfo,
    checkCircle,
    leftArrow,
    downArrowDefaultColor,
    chevronDown,
    buttonS,
    attention,
    greenTick,
    loading,
    star,
    starHalf,
    starFill,
    pinMapPrimary,
    profile,
    logout,
    receipt,
    pinmapOrange,
    badgeHot,
    badgeHotEmpty,
    badgeYellowBg,
    globe,
    dropdownSelect,
    cocukDunyasi
}